module.exports = __webpack_public_path__ + "img/DIEN_TU_CONG_NGHE.7fbe1a21.svg";